import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-deal-id-explaination-popup',
  templateUrl: './deal-id-explaination-popup.component.html',
  styleUrls: ['./deal-id-explaination-popup.component.scss']
})
export class DealIdExplainationPopupComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public close() {
    this.activeModal.close();
  }

}
